export default "__VITE_ASSET__Dq7de27K__"